
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function AboutSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Founder Image */}
            <div className="order-2 lg:order-1">
              <img
                src="https://static.readdy.ai/image/f3375ab72d7f65b358dc6cf884e758f7/99d0d376faf7295cfa00e5627cf9bc5f.jpeg"
                alt="James Hansen - SparkBoost Labs CEO and founder"
                className="w-full max-w-lg mx-auto rounded-2xl shadow-2xl object-cover object-top"
              />
            </div>

            {/* Content */}
            <div className="order-1 lg:order-2">
              <h2 className="text-4xl font-bold text-[#1B365D] mb-6">
                Meet James Hansen, Your Revenue Systems Expert
              </h2>
              
              <p className="text-xl text-gray-600 mb-6">
                After experiencing the feast-or-famine cycle firsthand as a management consultant, 
                James discovered the power of AI-driven revenue systems.
              </p>
              
              <p className="text-lg text-gray-600 mb-8">
                Now, with over 12 years of experience and a proven methodology, he's helped 75+ 
                service companies in Sacramento break free from founder dependency and build 
                predictable, scalable revenue engines.
              </p>

              {/* Mission Statement */}
              <div className="bg-white rounded-lg p-6 shadow-lg mb-8">
                <h3 className="text-xl font-bold text-[#1B365D] mb-4">Our Mission</h3>
                <p className="text-gray-600">
                  "To eliminate the feast-or-famine cycle for service-based companies through 
                  AI-powered revenue systems and proven growth methodologies. Every business 
                  deserves predictable growth that scales beyond the founder."
                </p>
              </div>

              {/* Key Stats */}
              <div className="grid grid-cols-2 gap-6 mb-8">
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#2BB6A3] mb-2">12+ Years</div>
                  <div className="text-gray-600">Business Operations</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#2BB6A3] mb-2">75+ Companies</div>
                  <div className="text-gray-600">Transformed</div>
                </div>
              </div>

              <Link to="/about">
                <Button 
                  variant="primary" 
                  className="bg-[#1B365D] hover:bg-[#1B365D]/90 text-white whitespace-nowrap"
                >
                  Learn More About Our Story
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
